import { getUin } from '../user';

import { objectToGetParams, imgReport } from '../util';
import { getUrlParam } from '../url';
import { isObject, isArray } from '../type';

const accReportUrl = `${location.protocol}//ft.moneydata.hk/node/report/accLog`;

let businessName = "";
let appEnv = "production";
let accModule = "hkwallet_web"; //wepluscard_web ： 信用卡

export function setAccBusinessName(name){
    businessName = name
}

export function setAccEnv(accEnv){
    appEnv = accEnv
}

export function setAccModule(mobuleName){
    accModule = mobuleName
}


// http://x.code.oa.com/ppd-web/doc/blob/master/elk.md
/**
 * 上报情景：
 * 1.jserror
 * 2.ajax
 * 3.自定义上报
 */
export function acc(params) {
    if(appEnv !== 'production'){
        return;
    }
    // 1.格式化
    const elkParams = getAccObj(params);

    const formatParams = objectToGetParams(elkParams);
    // 2。上报
    const url = `${accReportUrl}${formatParams}`;
    imgReport(url);
}

export function getAccObj(params = {}) {
    const defaultConfig = {
        module: accModule,
        /* server */
        server: `${businessName}`,
        /* service */
        service: '',
        /* 请求耗时  微秒 */
        cost: '',
        /* 错误码 */
        retcode: '',
        /* 	扩展key1 */
        ext1: '',
        /* 	扩展key2 */
        ext2: '',
        /* 	扩展key3 */
        ext3: '',
        ext4: '',
        ext5: '',
        /* 	扩展key4 */
        //ext4: encodeURIComponent(location.hostname),
        /* 	扩展key5 */
        //ext5: encodeURIComponent(location.pathname),
        /* file */
        //file: encodeURIComponent(location.href),
        /* MSG_NO(染色ID ) */
        msgno: '',
        /* 返回包 */
        respack: '',
        /* 请求包 */
        reqpack: '',
        /* uin */
        uin: getUin()
    };
    const reportParams = {};
    Object.keys(defaultConfig).forEach(key => {
        let value = params[key] || defaultConfig[key];
        if (isObject(value) || isArray(value)) {
            value = JSON.stringify(value) || '';
        }
        // url需要encode一下
        // axios的post请求中 body的数据会被json.string 所以这里要encode一下
        if (['respack', 'reqpack'].indexOf(key) > -1) {
            // 需要encode
            value = encodeURIComponent(value) || '';
        }
        // 优先取传参数据内容，否则取默认配置
        if (value !== '') {
            reportParams[key] = value;
        }
    });
    return reportParams;
}

export function checkAccReport(url) {
    console.log(accReportUrl);
    return url === accReportUrl;
}


export function checkShouldSkipReport(url) {
    return getUrlParam('noreport', url) === '1';
}